<template>

  <div>

    <sc-field
      :label="label"
      :message="message"
      :type="message ? 'is-danger' : ''"
    >
      <sc-select class="form-control" v-model="selectedOption" @input="onChange" >
        <option v-if="!this.fieldSchema.required || !this.fieldSchema.default" disabled value="">Escolha uma opção</option>
        <option v-for="choice in fieldSchema.choices" :value="choice.name">

          {{ choice.title ? choice.title : choice.name }}

        </option>
      </sc-select>
    </sc-field>
    <br>
    <app-config-form :schemaBased="selectedSchemaBased" ref="appConfigForm" />

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScField,
  ScSelect,
} from "@intelipost-js/secure-components";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-modal-config-choice-field",

  props: {
    fieldSchema: {
      type: Object
    },
  },

  data() {
    return {
      label: '',
      message: '',
      selectedOption:'',
      oldSelectedOption:'',
      selectedSchemaBased: {
        fields: []
      }
    }
  },

  computed: {
    ...mapState(["appConfigUpdated"]),
  },

  methods: {

    ...mapActions([
      "updateAppConfig",
    ]),

    validate() {
      if (this.fieldSchema.required && !this.selectedOption) {

        this.message = 'A seleção de uma opção é obrigatória';
        return false;
      }

      this.message = '';
      return !this.$refs.appConfigForm || this.$refs.appConfigForm.validate();
    },

    onChange(){

      this.validate();

      this.selectedSchemaBased.fields = [
        this.fieldSchema.choices.find(choice => choice.name == this.selectedOption)
      ];

      this.updateChoiceFieldsInAppConfig();

      this.oldSelectedOption = this.selectedOption;
    },

    updateChoiceFieldsInAppConfig() {
      const appConfig = {
        ...this.appConfigUpdated,
      };

      if (this.oldSelectedOption) {
        delete appConfig[this.oldSelectedOption];
      }

      appConfig[this.fieldSchema.name] = this.selectedOption;

      this.updateAppConfig(appConfig);
    },
  },

  mounted() {
    this.label = this.fieldSchema.title;
    if (!this.label) this.label = this.fieldSchema.name;
    this.label += this.fieldSchema.required ? ' (Obrigatório)' : ' (Opcional)';

    this.selectedOption = this.appConfigUpdated[this.fieldSchema.name];

    if (!this.selectedOption) {
      this.selectedOption = this.fieldSchema.default;
    }

    if (this.selectedOption) {
      this.onChange();
    }
  },

  components:{
    ScField,
    ScSelect,
    'app-config-form': () => import('./AppConfigForm.vue')
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/components/ChoiceField.vue